export default "__VITE_ASSET__BcJi$xzl__"